import { useContext, useRef, useState } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { useNavigate } from "react-router";
import { API_ChangeMFAType, LoginResponseModel } from "../../../apis/ApisAuth";
import { MfaTypeModel } from "../../../apis/ApisAccountSecurity";

export type MfaFormProps = {
    setErrorCallback: (errors: string[]) => void,
    baseState: LoginResponseModel,
    inputUsername: string
    onCompleteCallback: (doLogic : boolean) => void,
}


export function MFAForm(props: MfaFormProps) {
    const app = useContext(AppContext);
    const inputMFARef = useRef<HTMLInputElement>(null);
    inputMFARef?.current?.classList.remove("is-valid");
    inputMFARef?.current?.classList.remove("is-invalid");
    const [inputMFA, setInputMFA] = useState<string>('');
    const [mfaHelperMessage, setHelperMessage] = useState<string>(props.baseState.MFAHelperMessage);
    const [mfaLocked, setMfaLocked] = useState<boolean>(props.baseState.MFALocked);
    const [mfaPicker] = useState<boolean>(props.baseState.MFATypes.length > 1);
    const [mfaType, setMfaType] = useState<MfaTypeModel>(props.baseState.MFATypes.length == 1 ? props.baseState.MFATypes[0] : null);
    let navigate = useNavigate();

    const tryMFALogin = async () => {
        if (inputMFA != '' && inputMFA.length > 0) {
            var res = await app.logInUserMFA(props.inputUsername, inputMFA, mfaType.Type);
            if (res.LoginSuccess) {
                props.setErrorCallback([]);
                inputMFARef?.current?.classList.add("is-valid");
                inputMFARef?.current?.classList.remove("is-invalid");
                props.onCompleteCallback(true);
            }
            else if (!res.MFALocked) {
                inputMFARef?.current?.classList.remove("is-valid");
                inputMFARef?.current?.classList.add("is-invalid");
                props.setErrorCallback([`Code is invalid`]);
            }
            else {
                inputMFARef?.current?.classList.remove("is-valid");
                inputMFARef?.current?.classList.remove("is-invalid");
                setMfaLocked(true);
                setMfaLockedMessage(res.MFALockedMin);
            }
        }
    }

    const pickMfaType = async (picked: MfaTypeModel) => {
        if (picked != null) {
            var res = await API_ChangeMFAType(props.inputUsername, picked.Type);

            if (res.Error != null && res.Error.length > 0) {
                props.setErrorCallback([`${res.Error}`]);
            }
            else {
                setMfaType(picked);

                if (res.MFALocked) {
                    setMfaLocked(true);
                    setMfaLockedMessage(res.MFALockedMin);
                }
                else {
                    setHelperMessage(res.MFAHelperMessage);
                }
            }
        }
    }

    const setMfaLockedMessage = (min: string) => {
        props.setErrorCallback([`Account is locked. Multi factor limit reached. Please try again after ${min} minutes`]);
    }

    if (props.baseState.MFALocked) {
        setMfaLockedMessage(props.baseState.MFALockedMin);
    }

    return (
        <>
            {!mfaLocked && <>
                {mfaPicker && !mfaType && <>
                    <label htmlFor="mfaselectcontrol" className="form-label-alt">Select verification type</label>
                    <select id="mfaselectcontrol" onChange={x => { x.preventDefault(); pickMfaType(props.baseState.MFATypes.find(t => t.Type == x.currentTarget.value)); }} defaultValue={""} className="form-select" aria-label="Select verification type">
                        <option value={""} key={"Please_select"}>Please select</option>
                        {props.baseState.MFATypes.map(x => { return <option key={x.Type} value={x.Type}>{x.Name}</option> })}
                    </select>
                </>}

                {(!mfaPicker || mfaType) &&
                    <>
                        <div className="col-auto">
                            <label htmlFor="mfacontrol" className="form-label-alt">Verification code</label>
                            <div className="input-group">
                                {props.baseState.MFATypes.length > 1 && <button className="btn btn-outline-secondary" type="button" id="btn-change" onClick={x => setMfaType(null)}>Change type</button>}
                                <input ref={inputMFARef} disabled={mfaLocked} maxLength={6} placeholder="Code" className="form-control" value={inputMFA} aria-label="Input verification code" id="mfacontrol" type="text" onChange={t => {
                                    setInputMFA(t.currentTarget.value);
                                    inputMFARef?.current?.classList.remove("is-valid");
                                    inputMFARef?.current?.classList.remove("is-invalid");
                                }} />
                            </div>
                            <div className="invalid-feedback">
                                Please provide a verification code
                            </div>
                        </div>

                        <div className="alert alert-info mt-2">{mfaHelperMessage}</div>

                        <button className="btn btn-secondary mt-2"
                            type="submit"
                            disabled={mfaLocked}
                            onClick={e => {
                                e.preventDefault();
                                tryMFALogin();
                            }}>Submit</button>
                    </>}
            </>}
            {mfaLocked && <div className="alert alert-danger">Account locked</div>}
        </>
    );
}